import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskCaseNotesRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-case-notes',
	path: '/jira/servicedesk/projects/:projectKey/settings/case-management/case-notes',
	exact: true,
};
